import cn from 'classnames';
import { t } from 'i18next';

import KdButton from './KdButton';

interface Props {
  className?: string;
  isBackButton?: boolean;
  isReverseButtons?: boolean;
  onBackClick?: () => void;
  renderButtons: React.ReactNode;
}

const KdButtonGroup = ({
  className,
  isBackButton = true,
  isReverseButtons = true,
  onBackClick,
  renderButtons,
}: Props) => {
  const classes = cn(
    'flex justify-between w-full sm:w-[470px] gap-[15px] sm:gap-[30px] mt-[30px]',
    { 'flex-col-reverse sm:flex-row': isReverseButtons },
    className
  );

  return (
    <div className={classes}>
      {isBackButton && (
        <KdButton
          variant="tertiary"
          onClick={onBackClick}
          fullOnMobile
        >
          {t('Go Back')}
        </KdButton>
      )}
      {renderButtons}
    </div>
  );
};
export default KdButtonGroup;
